import { createTheme } from "@mui/material/styles";

/**
 * Default MUI theme for the scheduler grid.
 * Scheduler layout CSS/JS targets Emotion class hashes from @aldabil/react-scheduler.
 * Those hashes change when the app-wide gold/black theme is applied, which breaks
 * the grid. Isolate the calendar under the default theme so hashes stay stable.
 */
const schedulerMuiTheme = createTheme();

export default schedulerMuiTheme;
